import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.gradle = bracketIndenting()
